export default [
	{
		colors: {
			defaultEventColorHex: '#000000',
			defaultGroupColorHex: '#AF43EB',
		},
	},
];
